import { FolderIcon } from '@heroicons/react/24/outline'
import { PhotoIcon, XMarkIcon } from '@heroicons/react/24/solid'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const Document = ({ isFolder, document, utils }: any) => {
    const {
        openFolder,
        selectedItems,
        setSelectedItems,
        fullGalleryData,
        parentFolder
    } = utils

    const selected = selectedItems.find(({ folderid, fileid }: any) => isFolder ? folderid === document.folderid : fileid === document.fileid)

    const [showCheckBox, setShowCheckBox] = useState(false)

    useEffect(() => {
        if (selectedItems.length === 0) {
            setShowCheckBox(false)
        } else {
            setShowCheckBox(Boolean(selected))
        }
    }, [selectedItems, fullGalleryData])

    const parentFolderName = parentFolder?.name ? parentFolder.name.replace(/ /g, "%20") : ""
    const fileName = document?.name ? document.name.replace(/ /g, "%20") : ""

    const url = `https://filedn.com/lT5gOEbzKYmfJKWq0U2Nvl7/Website/${parentFolderName}/${fileName}`

    const [showFullImage, setShowFullImage] = useState(false)

    return isFolder ? (
        <div
            className='flex gap-2 bg-[#f4f5f6] p-5 items-center rounded-lg shadow'

            onMouseEnter={() => !selected && setShowCheckBox(true)}
            onMouseLeave={() => !selected && setShowCheckBox(false)}
        >
            {
                showCheckBox ? (
                    <input
                        type="checkbox"
                        checked={Boolean(selected)}
                        className="w-5 h-5 mx-[2px] rounded-full border bg-white border-gray-400 checked:bg-green-800 cursor-pointer appearance-none"
                        onChange={(e) => {
                            const checked = e.target.checked
                            setSelectedItems((prev: any[]) => {
                                if (checked) {
                                    return [...prev, document]
                                } else {
                                    return prev.filter(({ folderid }: any) => folderid !== document.folderid)
                                }
                            })
                        }}
                    />
                ) : (
                    <FolderIcon width={24} />
                )
            }
            <p
                onClick={() => {
                    openFolder()
                    setSelectedItems([])
                }}
                className={`cursor-pointer hover:underline`}
            >
                {document.name}
            </p>
        </div>
    ) : (
        <>
            {showFullImage && (
                createPortal(
                    <div className='fixed flex flex-col bg-black z-20 inset-0  w-screen h-screen'>
                        <div className='bg-black flex justify-between items-center p-5'>
                            <div className='flex items-center gap-2 text-white'>
                                <PhotoIcon height={20} />
                                <p>{document.name}</p>
                            </div>
                            <XMarkIcon height={40} className='text-white cursor-pointer' onClick={() => setShowFullImage(false)} />
                        </div>
                        <LazyLoadImage
                            src={url}
                            alt={document.name}
                            effect='blur'
                            className='max-w-[800px] mx-auto'
                        />
                    </div>,
                    window.document.getElementById('popup')!!
                )
            )}
            <div
                className="
                    relative flex items-center justify-center h-[90px] rounded-lg overflow-clip
                    after:absolute after:inset-0 after:bg-black after:opacity-0 after:pointer-events-none
                    hover:after:opacity-10 transition-all ease-in-out cursor-pointer shadow-xl
                "
                onMouseEnter={() => !selected && setShowCheckBox(true)}
                onMouseLeave={() => !selected && setShowCheckBox(false)}
            >
                {showCheckBox && (
                    <input
                        type="checkbox"
                        checked={Boolean(selected)}
                        className="w-5 h-5 left-1 top-1 absolute z-10 rounded-full bg-white border border-gray-400 checked:bg-green-800 cursor-pointer appearance-none"
                        onChange={(e) => {
                            const checked = e.target.checked
                            setSelectedItems((prev: any[]) => {
                                if (checked) {
                                    return [...prev, document]
                                } else {
                                    return prev.filter(({ fileid }: any) => fileid !== document.fileid)
                                }
                            })
                        }}
                    />
                )}
                <LazyLoadImage
                    src={url}
                    alt={document.name}
                    effect='blur'
                    className='object-cover cursor-pointer'
                    onClick={() => setShowFullImage(true)}
                />
            </div>
        </>
    )
}

export default Document